import React from 'react'
import PasswordUpdateForm from '../components/PasswordUpdateForm'

const ChangePasswordPage = () => {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Change Password</h3>
      <div className="bg-white dark:bg-slate-800 rounded-lg p-6 shadow-sm border border-gray-200 dark:border-gray-700 max-w-md">
        <PasswordUpdateForm />
      </div>
    </div>
  )
}

export default ChangePasswordPage
